import React from "react";
import { useNavigate, Link } from "react-router-dom";

export default function MBGHome() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-between bg-gradient-to-b from-emerald-900 via-teal-900 to-emerald-950 text-white p-4">
      {/* Main Content */}
      <div className="flex flex-col items-center text-center mt-8 sm:mt-12 max-w-md">
        {/* Emoji */}
        <div className="text-6xl sm:text-7xl mb-4">👩‍🌾</div>

        {/* Title */}
        <h1 className="text-3xl sm:text-4xl font-bold mb-2">
          Mahila Bachat Gat (MBG)
        </h1>

        {/* Subtitle */}
        <h2 className="text-lg sm:text-xl text-emerald-200 mb-3">
          Women Self-Help Empowerment Network
        </h2>

        {/* 2-Line Explainer */}
        <p className="text-sm sm:text-base text-gray-200 mb-6 leading-relaxed">
          A community of self-reliant women driving financial inclusion, 
          savings, and entrepreneurial growth through collective support and learning. 
          Join hands to build stronger families and communities.
        </p>

        {/* Action Button */}
        <button
          onClick={() => navigate("/sheearns")}
          className="bg-pink-600 hover:bg-pink-700 text-white font-semibold 
                     py-3 px-6 rounded-lg shadow-md transition-all duration-200 
                     hover:scale-105 active:scale-95"
        >
          🌸 Start Your Journey
        </button>
      </div>

      {/* Footer */}
      <footer className="bg-[#2a0f2f] border-t border-pink-800 text-pink-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-xs lg:text-sm">
                © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
            </div>
            <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
                <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
                <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
                <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
            </div>
        </div>
      </footer>
    </div>
  );
}
